export enum ExternalIdProvider {
  BankId = 0,
  Authologic = 1,
  Partner = 2,
}
